<template>
    <!-- POPUP START CHAT -->
    <div class="well well-sm chat-toggle-popover"
         v-if="activeScreen === ScreensEnum.chatPopup">
        <div class="panel panel-default">
            <div class="panel-body">
                <p v-html="message"></p>
            </div>
        </div>
        <button @click="nextScreen(ScreensEnum.startConversation)" class="btn branding-background branding-text" id="">Let's Chat</button> <a @click.prevent="nextScreen(ScreensEnum.chatButton)" href="" title="Hide Chat">Maybe Later</a>
    </div><!--well-->
</template>

<script>
import screenNavMixin from '../mixins/screen-nav';

export default {
    mixins: [screenNavMixin],
    template: "#chat-popup-template",
    data: function() {
        return {};
    },
    props: {
        delayInSeconds: {
            type: Number
        },
        message: {
            type: String,
            required: true
        },
        enabled: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        sayHi: function() {
            // if delay property is set then do the popup,
            // otherwise ignore...
            if (this.delayInSeconds && this.enabled) {
                setTimeout(
                    function() {
                        // Only do this if the launch button is visible
                        if (this.activeScreen === this.ScreensEnum.chatButton) {
                            this.nextScreen(this.ScreensEnum.chatPopup);
                        }
                    }.bind(this),
                    this.delayInSeconds * 1000
                );
            }
        }
    },
    mounted: function() {
        this.sayHi();
    }
};
</script>

<style>
</style>